import {AfterContentInit, Component, ContentChildren, Input, OnDestroy, QueryList} from "@angular/core";
import {EntityActionComponent} from "./entity-action.component";
import {ReplaySubject, Subscription} from "rxjs";

@Component({
    selector: "wbo-entity-actions",
    template: "<ng-content></ng-content>"
})
export class EntityActionsComponent implements AfterContentInit, OnDestroy {
    @Input() title: string;

    private subscriptions: Subscription = new Subscription();

    actions$: ReplaySubject<EntityActionComponent[]> = new ReplaySubject(1);

    @ContentChildren(EntityActionComponent) _actions: QueryList<EntityActionComponent>;

    ngAfterContentInit(): void {
        this.actions$.next(this._actions.toArray());
        this.subscriptions.add(this._actions.changes.subscribe(() => this.actions$.next(this._actions.toArray())));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
